import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createGame(_, game) {
    const response = await axios.post('/blade/games', game);
    return response.data.game;
  },
  async getGames() {
    const response = await axios.get('/blade/games');
    return response.data.games;
  },
  async getAssignedGames() {
    const response = await axios.get('/blade/assignedGames');
    return response.data.games;
  },
  async getAllAssociatedGames() {
    const response = await axios.get('/blade/allAssociatedGames');
    return response.data.games;
  },
  async getGame(_, { gameId }) {
    const { data } = await axios.get(`/blade/games/${gameId}`);
    return data;
  },
  async getGameTypes({ dispatch }) {
    return dispatch('getGame', { gameId: 'types' });
  },
  async getGameEnums() {
    const { data } = await axios.get('/blade/gameEnums');
    return data;
  },
  async updateGame(_, game) {
    const response = await axios.patch(`/blade/games/${game._id}`, game);
    return response.data.game;
  },
  async syncGameWithGoogleSheet(_, game) {
    const response = await axios.patch(
      `/blade/games/${game._id}/sheetsync/${game.lastSyncedSheetId}`,
      { origin: window.origin },
    );
    return response.data.game;
  },
  async recomputeGameLength(_, { gameId, _id }) {
    const did = gameId || _id;
    const response = await axios.get(`/game/demo/${did}/length?recompute=true`);
    return response.data;
  },
  async deleteGame(_, { gameId, _id }) {
    const did = gameId || _id;
    const response = await axios.delete(`/blade/games/${did}`);
    return response.data.game;
  },
  async generateGameInvite(_, game) {
    const response = await axios.patch(`/blade/games/invite/${game._id}`);
    return response.data.game;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/games.js